import { render, staticRenderFns } from "./MTooltip.vue?vue&type=template&id=229e61ff&scoped=true&"
import script from "./MTooltip.vue?vue&type=script&lang=js&"
export * from "./MTooltip.vue?vue&type=script&lang=js&"
import style0 from "./MTooltip.vue?vue&type=style&index=0&id=229e61ff&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e61ff",
  null
  
)

export default component.exports